import { Component, OnInit, Input, ViewChild, ElementRef, OnChanges, ViewEncapsulation } from '@angular/core';
import { NgModel, ControlContainer, NgForm } from '@angular/forms';
import { TreeNode } from 'primeng/api';

// Models
import { StudyViewModel } from '../../viewmodel/study.viewmodel';

// Services
import { TreeViewService } from '../../services/treeview.service';

// Constants
import { RegularExpressionPattern } from '../../shared/_constants';
import { ConfigService } from '../../services/config.service';
import { Industry } from '@models/industry.model';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-testedpartyinfo',
  templateUrl: './testedPartyInfo.component.html',
  styleUrls: ['./testedPartyInfo.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  encapsulation: ViewEncapsulation.None,
})
export class TestedPartyInfoComponent implements OnInit {
  @Input() studyVM: StudyViewModel = new StudyViewModel();

  @Input() submitted = false;
  @Input() isNewStudyIndustryBlank = false;
  selectedIndustry: Industry;
  studyIndustries: Industry[] | undefined;
  filteredIndustries: Industry[] | undefined;
  regularExpressionPattern = RegularExpressionPattern;
  showValidationMessage = false;

  // Load all Region and Country
  selectedTestedPartyCountryNodes: TreeNode[] = [];
  testedPartyBusinessDescriptionMinLength = 0;

  constructor(
    private treeviewService: TreeViewService,
    private configService: ConfigService,
  ) {
    this.configService.getConfigValue(ConfigService.TESTED_PARTY_BUSINEDD_DESCRIPTION_MIN_LENGTH).subscribe((value) => {
      if (value) this.testedPartyBusinessDescriptionMinLength = +value;
    });
  }
  ngOnChanges() {
    if (this.studyVM.study.industryId === this.studyVM.otherIndustryId) {
      this.showValidationMessage = true;
      this.studyVM.study.industryId = 0;
    }
    if (this.studyVM.industries.length > 0) {
      this.studyIndustries = this.studyVM.industries.filter((x) => x.industryId != this.studyVM.otherIndustryId);
      this.selectedIndustry = this.studyIndustries.find((x) => x.industryId == this.studyVM.study.industryId);
    }
    if (this.isNewStudyIndustryBlank) {
      this.showValidationMessage = true;
    }
  }
  ngOnInit() {
    this.treeviewService.checkNode(
      this.studyVM.testedpartyregionCountries_multi,
      this.studyVM.selectedTestedPartyCountries,
      this.selectedTestedPartyCountryNodes,
    );
  }
  checkNewStudyValidation() {
    this.showValidationMessage = this.isNewStudyIndustryBlank;
  }
  ShowValidationMessage(item: NgModel): boolean {
    return item.errors && (this.submitted || !item.pristine || item.touched);
  }

  nodeSelect(event) {
    this.treeviewService.addNode(event.node, this.studyVM.selectedTestedPartyCountries);
    this.selectedTestedPartyCountryNodes = [];
    this.treeviewService.checkNode(
      this.studyVM.testedpartyregionCountries_multi,
      this.studyVM.selectedTestedPartyCountries,
      this.selectedTestedPartyCountryNodes,
    );
  }

  nodeUnselect(event) {
    this.treeviewService.removeNode(event.node, this.studyVM.selectedTestedPartyCountries);
    this.selectedTestedPartyCountryNodes = [];
    this.treeviewService.checkNode(
      this.studyVM.testedpartyregionCountries_multi,
      this.studyVM.selectedTestedPartyCountries,
      this.selectedTestedPartyCountryNodes,
    );
  }

  filterIndustries(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.studyIndustries as Industry[]).length; i++) {
      let industry = (this.studyIndustries as Industry[])[i];
      if (industry.industryName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(industry);
      }
    }

    this.filteredIndustries = filtered;
  }
  IndustrySelected(event: Industry) {
    this.selectedIndustry = event;
    this.showValidationMessage = false;
    this.studyVM.study.testedPartyIndustry = this.selectedIndustry;
    this.studyVM.study.industryId = this.selectedIndustry.industryId;
  }
  clearTextbox() {
    this.showValidationMessage = true;
    this.selectedIndustry = undefined;
    this.studyVM.study.industryId = 0;
  }
}
